const AuthLoading = () => {
    return (
        <div className="bg-white fixed h-full w-full top-0 z-50">
            <div className="flex items-center justify-center w-full h-full">
                <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    );
};

export default AuthLoading;
